var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutubeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 159,
    height: 110,
    viewBox: "0 0 159 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M154 17.4999C152.18 10.7699 146.93 5.49993 140.2 3.69993C131.16 0.209927 43.6 -1.50007 18.2 3.79993C11.47 5.61993 6.20001 10.8699 4.40001 17.5999C0.320011 35.4999 0.010011 74.1999 4.50001 92.4999C6.32001 99.2299 11.57 104.5 18.3 106.3C36.2 110.42 121.3 111 140.3 106.3C147.03 104.48 152.3 99.2299 154.1 92.4999C158.45 72.9999 158.76 36.6999 154 17.4999Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M154 17.4999C152.18 10.7699 146.93 5.49993 140.2 3.69993C131.16 0.209927 43.6 -1.50007 18.2 3.79993C11.47 5.61993 6.20001 10.8699 4.40001 17.5999C0.320011 35.4999 0.010011 74.1999 4.50001 92.4999C6.32001 99.2299 11.57 104.5 18.3 106.3C36.2 110.42 121.3 111 140.3 106.3C147.03 104.48 152.3 99.2299 154.1 92.4999C158.45 72.9999 158.76 36.6999 154 17.4999Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M105 55.0001L64.2 31.6001V78.4001L105 55.0001Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M105 55.0001L64.2 31.6001V78.4001L105 55.0001Z",
    fill: "#090909"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube-icon.ec98bd6dfce7ea416136fa9101798412.svg";
export { ForwardRef as ReactComponent };